import React from "react";

type Props = {
  width?: number;
  height?: number;
  color?: string;
};

const IconTAWoundsInjuries = ({
  width = 24,
  height = 24,
  color = "#515C6C",
}: Props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M14.6924 11.5C15.5934 11.5 16.4576 11.858 17.0947 12.4951C17.7318 13.1323 18.0898 13.9964 18.0898 14.8975V19.5C18.0898 19.7761 17.8659 19.9999 17.5898 20C17.3137 20 17.0898 19.7761 17.0898 19.5V14.8975C17.0898 14.2616 16.8373 13.6518 16.3877 13.2021C15.9381 12.7526 15.3282 12.5 14.6924 12.5H11.5664L12.0664 16.5H14.4248C14.8957 16.5 15.393 16.6209 15.7881 16.8887C16.1967 17.1656 16.5007 17.6086 16.5 18.1953C16.4992 18.8095 16.1869 19.279 15.7578 19.5771C15.3415 19.8663 14.8139 20 14.3076 20H12.4971C12.497 20.1211 12.456 20.2393 12.375 20.3311C12.2801 20.4386 12.1434 20.5 12 20.5H8C7.85659 20.5 7.71991 20.4386 7.625 20.3311C7.54399 20.2393 7.50299 20.1211 7.50293 20H6C5.72386 20 5.5 19.7761 5.5 19.5V14.8975C5.5 13.9964 5.85797 13.1323 6.49512 12.4951C7.13226 11.858 7.9964 11.5 8.89746 11.5H14.6924ZM8.71094 18.3389L8.56641 19.5H11.4336L11.1504 17.2344L8.71094 18.3389ZM8.42773 12.5469C7.96685 12.639 7.53938 12.8649 7.20215 13.2021C6.75254 13.6518 6.5 14.2616 6.5 14.8975V19H7.62109L8.42773 12.5469ZM12.3789 19H14.3076C14.653 19 14.9708 18.9064 15.1875 18.7559C15.3912 18.6143 15.4996 18.4317 15.5 18.1943L15.4961 18.1211C15.4765 17.9559 15.3872 17.824 15.2275 17.7158C15.0317 17.5831 14.7406 17.5 14.4248 17.5H12.1914L12.3789 19ZM8.85645 17.1768L11.0205 16.1963L10.9092 15.3066L9.21387 14.3145L8.85645 17.1768ZM9.34863 13.2344L10.7529 14.0557L10.5586 12.5H9.44141L9.34863 13.2344ZM12 3.5C13.2973 3.5 14.4286 4.20637 15.0332 5.25488C15.0381 5.26363 15.0434 5.27215 15.0479 5.28125C15.3349 5.7891 15.5 6.37504 15.5 7C15.5 8.933 13.933 10.5 12 10.5C10.0791 10.5 8.52036 8.95248 8.50098 7.03613C8.50083 7.03417 8.50012 7.03224 8.5 7.03027V7C8.5 5.067 10.067 3.5 12 3.5ZM9.53027 7.375C9.71135 8.57765 10.7469 9.5 12 9.5C13.3807 9.5 14.5 8.38071 14.5 7C14.5 6.67881 14.4365 6.37291 14.3262 6.09082L9.53027 7.375ZM10.3662 5.11035C10.0013 5.42615 9.72901 5.84472 9.59473 6.32227L11.4658 5.82031L10.3662 5.11035ZM12 4.5C11.7878 4.5 11.5825 4.52934 11.3857 4.5791L12.7695 5.47168L13.7432 5.21094C13.2927 4.77196 12.6787 4.5 12 4.5Z"
        fill={color}
        className="therapeutic-area-icon-fill"
      />
    </svg>
  );
};

IconTAWoundsInjuries.displayName = "TAWoundsInjuries";

export default IconTAWoundsInjuries;
